import { render } from "./OverviewPanel.vue?vue&type=template&id=56270d63&scoped=true"
import script from "./OverviewPanel.vue?vue&type=script&lang=js"
export * from "./OverviewPanel.vue?vue&type=script&lang=js"

import "./OverviewPanel.vue?vue&type=style&index=0&id=56270d63&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56270d63"]])

export default __exports__